import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import Header from './Header';
import Sidebar from './Sidebar';
import AnnouncementBanner from './AnnouncementBanner';
import SupportChatWidget from './SupportChatWidget';
import AgentBotWorkspaceOverlay from '@/components/agent/AgentBotWorkspaceOverlay';
import { useAuthStore } from '@/store/auth.store';
import { useAgentSelectedBotStore } from '@/store/agentSelectedBot.store';
import './MainLayout.css';

const { Content } = Layout;

const MainLayout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const user = useAuthStore((s) => s.user);
  const clearAgentBot = useAgentSelectedBotStore((s) => s.clearSelection);

  useEffect(() => {
    if (user?.role?.toLowerCase() !== 'agent') return;
    const sel = useAgentSelectedBotStore.getState().selection;
    if (!sel?.id) return;
    const ids = user.agentBotIds;
    /** Only clear when assignments are known and the saved bot is not allowed. */
    if (Array.isArray(ids) && ids.length > 0 && !ids.includes(sel.id)) {
      clearAgentBot();
    }
  }, [user?.id, user?.role, user?.agentBotIds, clearAgentBot]);

  return (
    <Layout className="main-layout">
      {/* Mobile menu button */}
      <Button
        type="primary"
        icon={<MenuOutlined />}
        className="mobile-menu-btn"
        onClick={() => setMobileMenuOpen(true)}
        aria-label="Open menu"
      />

      <Sidebar
        mobileOpen={mobileMenuOpen}
        onMobileClose={() => setMobileMenuOpen(false)}
      />
      <Layout className="site-layout">
        <Header />
        <Content className="main-content">
          <AnnouncementBanner />
          <Outlet />
        </Content>
      </Layout>
      <SupportChatWidget />
      <AgentBotWorkspaceOverlay />
    </Layout>
  );
};

export default MainLayout;

